if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"borrow","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(73[02]|(23|65|97)6|30|369|822)|2(051|154|32|672|866)|4([79]22|263|66|880)|5(418|438|716)|8(018|369|456|884|89)|3090|352|6004|6682|7237|7901|9148|9811)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}